module.exports = __webpack_public_path__ + "img/footer.edc46c30.png";